import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=2effb409&"
import script from "./ImageOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&id=2effb409&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports